/**
 * @generated SignedSource<<f82f992ea236ef676de7560652c274fa>>
 * @relayHash 2f109e4347be08608f4f7aa194ddd5be
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID 9c945938f00ec4ee66af1ff0966431ca629e543a150102f72be8ed7806dc8a93

import type { ConcreteRequest, Query } from 'relay-runtime';
import type { FragmentRefs } from "relay-runtime";
export type pickerContentRefetchQuery$variables = {
  cloudId: string;
  issueAris?: ReadonlyArray<string> | null | undefined;
  searchStr?: string | null | undefined;
};
export type pickerContentRefetchQuery$data = {
  readonly " $fragmentSpreads": FragmentRefs<"pickerContent_autodevAgentPicker_agentsFragRef">;
};
export type pickerContentRefetchQuery = {
  response: pickerContentRefetchQuery$data;
  variables: pickerContentRefetchQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "cloudId"
  },
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "issueAris"
  },
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "searchStr"
  }
],
v1 = {
  "kind": "Variable",
  "name": "cloudId",
  "variableName": "cloudId"
},
v2 = {
  "kind": "ScalarField",
  "name": "id"
};
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "name": "pickerContentRefetchQuery",
    "selections": [
      {
        "args": [
          {
            "kind": "Variable",
            "name": "issueAris",
            "variableName": "issueAris"
          },
          {
            "kind": "Variable",
            "name": "searchStr",
            "variableName": "searchStr"
          }
        ],
        "kind": "FragmentSpread",
        "name": "pickerContent_autodevAgentPicker_agentsFragRef"
      }
    ],
    "type": "Query"
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "pickerContentRefetchQuery",
    "selections": [
      {
        "args": [
          (v1/*: any*/),
          {
            "kind": "Literal",
            "name": "first",
            "value": 20
          },
          {
            "kind": "Variable",
            "name": "issueIds",
            "variableName": "issueAris"
          },
          {
            "kind": "Variable",
            "name": "query",
            "variableName": "searchStr"
          }
        ],
        "concreteType": "DevAiRovoAgentConnection",
        "kind": "LinkedField",
        "name": "devai_autodevRovoAgents",
        "plural": false,
        "selections": [
          {
            "kind": "ScalarField",
            "name": "isRankingLimitApplied"
          },
          {
            "concreteType": "DevAiRovoAgentEdge",
            "kind": "LinkedField",
            "name": "edges",
            "plural": true,
            "selections": [
              {
                "concreteType": "DevAiRovoAgent",
                "kind": "LinkedField",
                "name": "node",
                "plural": false,
                "selections": [
                  {
                    "kind": "ScalarField",
                    "name": "name"
                  },
                  (v2/*: any*/),
                  {
                    "kind": "ScalarField",
                    "name": "description"
                  },
                  {
                    "kind": "ScalarField",
                    "name": "identityAccountId"
                  },
                  {
                    "kind": "ScalarField",
                    "name": "externalConfigReference"
                  },
                  {
                    "kind": "ScalarField",
                    "name": "rankCategory"
                  }
                ]
              }
            ]
          }
        ]
      },
      {
        "alias": "devai_autodevRovoTemplates",
        "args": [
          (v1/*: any*/),
          {
            "kind": "Literal",
            "name": "first",
            "value": 1
          },
          {
            "kind": "Literal",
            "name": "templatesFilter",
            "value": "ONLY"
          }
        ],
        "concreteType": "DevAiRovoAgentConnection",
        "kind": "LinkedField",
        "name": "devai_autodevRovoAgents",
        "plural": false,
        "selections": [
          {
            "concreteType": "DevAiRovoAgentEdge",
            "kind": "LinkedField",
            "name": "edges",
            "plural": true,
            "selections": [
              {
                "concreteType": "DevAiRovoAgent",
                "kind": "LinkedField",
                "name": "node",
                "plural": false,
                "selections": [
                  (v2/*: any*/)
                ]
              }
            ]
          }
        ]
      }
    ]
  },
  "params": {
    "id": "9c945938f00ec4ee66af1ff0966431ca629e543a150102f72be8ed7806dc8a93",
    "metadata": {},
    "name": "pickerContentRefetchQuery",
    "operationKind": "query",
    "text": null
  }
};
})();

(node as any).hash = "505e6085969b7f1e0b8f5e42ec8b4d40";

export default node;
